import { z } from 'zod';

export const channelSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'نام کانال الزامی است')
    .max(100, 'نام کانال نباید بیش از ۱۰۰ کاراکتر باشد'),

  channel_type_id: z
    .number({
      invalid_type_error: 'نوع کانال الزامی است',
      required_error: 'نوع کانال الزامی است',
    })
    .min(1, 'نوع کانال الزامی است'),

  is_active: z.boolean().optional(),
});
